import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, Checkbox, Modal, Text } from '@reveni-io/reveni-ui'

import useConsentCheckbox from './hooks/useConsentCheckbox/useConsentCheckbox'
import * as Styles from './styles'

const ConsentModal = ({ show, consentModal, onConfirm, onClose }) => {
  const { t, i18n } = useTranslation()
  const theme = useTheme()
  const { checked, showError, handleChange, handleConfirm } = useConsentCheckbox({ onConfirm })

  if (!consentModal) return null

  return (
    <Modal size="m" title={consentModal.title[i18n.language]} show={show} onClose={onClose}>
      <Styles.Container>
        <Text type="bodyMRegular">{consentModal.description[i18n.language]}</Text>
        <Styles.CheckboxContainer>
          <Checkbox
            name="consent"
            label={consentModal.checkbox_text[i18n.language]}
            checked={checked}
            onChange={handleChange}
            error={showError}
          />
          {showError && (
            <Text type="bodyXSRegular" color={theme.colors.danger.default}>
              {t('Debes marcar esta casilla para continuar')}
            </Text>
          )}
        </Styles.CheckboxContainer>
        <Button fullWidth onClick={handleConfirm}>
          {t('Confirmar')}
        </Button>
      </Styles.Container>
    </Modal>
  )
}

export default ConsentModal
